<template lang="pug">
	#sfc-main-container.sfc-container-redesign-v1
		sfc-sentry
		sfc-gtm-body
		sfc-dfp
		sfc-heap
		sfc-sponsored-plan-interstitial-v1(v-if="displayInterstitial" @continue="handleContinue()" @close="displayInterstitial = false")
		sfc-menu-mobile.menu-mobile(v-if="!displayInterstitial" :class="{'without-subscription': !hasSubscription}")
		sfc-onboarding-modal-v2(v-if="!displayInterstitial")
		#sfc-main-content.savings-center-container(v-if="!displayInterstitial")
			.sidebar-container
				sidebar
			.main-content(:class="{'has-subscription': hasSubscription}")
				nuxt
		

</template>

<style lang="stylus">
html
	body
	#__layout
	#__nuxt
		#sfc-main-content.savings-center-container
			font-family: "IBM Plex Sans", sans-serif!important
			*
				font-family: "IBM Plex Sans", sans-serif!important
			h1
			h2
			h3
			.navigation-title
			b
				font-family: "IBM Plex Serif", serif!important
				font-weight: bold

</style>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.padding-only-desktop
		border: 1px solid blue

	#sfc-main-container
		.menu-mobile
			position: relative !important
			top: 0
			width: 100%
			&.without-subscription
				>>> .hamburger-icon
					display: none
				>>>.sfc-logo-mobile
					@media(max-width: 280px)
						display: block !important

			>>> .search-icon
				display: none
		@media(max-width: 991px)
			width: 100%

		.menu-desktop
			position: fixed !important
			top: 0


		height: 100%



	.sidebar-container
		z-index: 200
		height: 100%
		position: fixed
		top: 0
		@media(max-width: 991px)
			min-height: 80px
			max-height: 110px
			top: auto
			bottom: -1px
			width: 100%
			height: 80px
			position: fixed

		// Iphone X generation
		@media only screen and (width: 375px) and (height: 812px) and (-webkit-device-pixel-ratio: 3)
			height: 110px
		@media only screen and (width: 414px) and (height: 896px) and (-webkit-device-pixel-ratio: 2)
			height: 110px
		@media only screen and (width: 375px) and (height: 812px) and (-webkit-device-pixel-ratio: 3)
			height: 110px
		@media only screen and (width: 414px) and (height: 896px) and (-webkit-device-pixel-ratio: 3)
			height: 110px

	.main-content
		margin-left: 200px
		width: calc(100% - 200px)
		display: inline-block
		@media(max-width: 991px)
			margin-left: 0
			width: 100%
			padding-bottom: 79px

		&.has-subscription
			padding-top: 45px
			@media(max-width: 575px)
				padding-top: 0


	#sfc-main-container
		height: 100%

		>>> .savings-center-container
			background-color: sfc-pale-stone

	>>> .header
		padding: 40px 60px 0px 30px
		h2
			line-height: 1

	.feedback-modal
		.step
			h3
				text-align: center
			p
				text-align: center
				margin-bottom: 0
				&.with-margin
					margin-top: 40px
				&:last-child
					margin-bottom: 40px
				&.last
					line-height: body-font-line-height-sm

			.icons-container
				margin: 60px auto 20px auto
				max-width: 300px
				text-align: center
				&.thanks
					margin: 40px auto 20px auto
				img
					padding: 20px 15px
					border: 1px solid sfc-pale-gray
					border-radius()
					sfc-box-shadow-card()
					&:nth-child(2)
						margin-left: 50px
				&.actionable
					img
						cursor: pointer

			.input
				margin-top: 40px
			.button
				margin-top: 20px
				&.disabled
					cursor: not-allowed
					opacity: 0.5

</style>

<script>
import SfcHeader from '@/layouts/common/sfc-header-slim'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import Sidebar from '@/common/components/savings-center/v3/sidebar'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'
import SfcInput from '@/common/components/inputs/v2/textbox'
import SfcButton from '@/common/components/sfc-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"
import SfcSponsoredPlanInterstitialV1 from "@/common/components/savings-center/v3/sfc-sponsored-plan-interstitial-v1"

export default {
	middleware: ['savings-center'],

	components: {
		SfcHeader,
		SfcFooter,
		SfcMenu,
		SfcMenuMobile,
		Sidebar,
		SfcOnboardingModalV2,
		SfcInput,
		SfcButton,
		SfcSponsoredPlanInterstitialV1
	},

	watch: {
		'$route': function (new_route, old_route) {
			// Display Interstitial everytime
			// if (!this.$store.state.savingsCenterInterstitial.opened && new_route.path == "/savings-center/open-a-plan"){

			if (new_route.path == "/savings-center/open-a-plan"){
				if (window && window.innerWidth >= 720) {
					this.displayInterstitial = true
					this.$store.commit('updateSavingsCenterInterstitial', {opened: true})
				}
			}else{
				this.displayInterstitial = false
			}
		}
	},

	data(){
		return {
			currentStep: "init",
			feedback: "",
			loading: false,
			mouseY: 101,
			feedbackValue: false,
			displayInterstitial: false
		}
	},

	mounted(){
		document.addEventListener("mousemove", this.handleMouseMove);
		if (window && window.innerWidth < 720) {
			this.displayInterstitial = false
		}
	},

	created(){

		//if (!this.$store.state.savingsCenterInterstitial.opened && this.$route.path == "/savings-center/open-a-plan"){
		if (this.$route.path == "/savings-center/open-a-plan"){
			this.displayInterstitial = true
			this.$store.commit('updateSavingsCenterInterstitial', {opened: true})
		}else{
			this.displayInterstitial = false
		}
	},

	beforeDestroy(){
		document.removeEventListener("mousemove", this.handleMouseMove);
	},

	computed: {
		isGold(){
			if (this.$store.state.sfcSubscriptions && (this.$store.state.sfcSubscriptions.is_gold_member || this.$store.state.sfcSubscriptions.is_admin_member)) {
				return true
			}
			return false
		},

		isPlatinium(){
			if (this.$store.state.sfcSubscriptions && (this.$store.state.sfcSubscriptions.is_platinium_member || this.$store.state.sfcSubscriptions.is_admin_member)) {
				return true
			}
			return false
		},

		hasSubscription(){
			return this.isGold || this.isPlatinium
		}
	},

	methods: {
		handleMouseMove(e){
			this.mouseY = e.clientY
			if(this.mouseY < 2 && !this.$cookies.get("sfc-sc-feedback-modal-triggered")){
				this.$cookies.set("sfc-sc-feedback-modal-triggered", true, {
					path: '/',
					domain: 'savingforcollege.com',
					maxAge: 365 * 24 * 60 * 60
				})
				this.showFeedbackModal()
			}
		},

		showFeedbackModal(){
			this.$sfcModal.open("sfc-sc-feedback-modal")
			SfcTrackingService.trackAnalyticsAction("Savings Center", "show", "SC Feedback Modal", 1)
		},

		closeFeedbackModal(){
			SfcTrackingService.trackAnalyticsAction("Savings Center", "close", "SC Feedback Modal", 0)
		},

		async submitFeedback(){
			let query = `
				mutation{
					create_savings_center_feedback(email: "${this.$store.state.userEmail}", positive_experience: ${this.currentStep == 'thank-you-yes'})
				}
			`

			let response = await this.$httpService.graphql(query)
		},

		async submitFeedbackText(){
			if(this.feedback.trim() == "" || this.loading){
				return
			}

			this.loading = true

			let query = `
				mutation{
					update_savings_center_feedback(email: "${this.$store.state.userEmail}", feedback: "${this.feedback.trim()}")
				}
			`

			let response = await this.$httpService.graphql(query)
			this.goToNextStep("thank-you-no")
		},

		goToNextStep(step){
			switch (step) {
				case "thank-you-yes":
					this.currentStep = "thank-you-yes"
					this.submitFeedback()
					SfcTrackingService.trackAnalyticsAction("Savings Center", "yes", "SC Feedback Modal", 0)
					this.feedbackValue = true
					break
				case "no":
					this.currentStep = "no"
					this.submitFeedback()
					SfcTrackingService.trackAnalyticsAction("Savings Center",  "no", "SC Feedback Modal", 0)
					break
				case "thank-you-no":
					this.currentStep = "thank-you-no"
					SfcTrackingService.trackAnalyticsAction("Savings Center", "submit", "SC Feedback Modal", 0)
					break
			}
		},

		handleContinue(){
			this.displayInterstitial = false
		}
	},
	head(){
			return {
				title: `Savings Center - Saving for College`,
				meta: [
					{hid: "metadescription", name: 'description', content: `Savings Center - Saving for College`}
				],
			}
		}
}
</script>
